/**
 * @flow
 * @author: Pavan
 */

import styled from 'react-emotion'

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  user-select: none;
`
export default IconContainer



// WEBPACK FOOTER //
// ./src/commons/StyledComponents/View/IconContainer.js